module.exports = __webpack_public_path__ + "components/intersport-discount-page/promo-article/static/article-image@2-caa5ed60bc5c419dbc66a612e49b3d1b.webp";